export const SET_STATE = 'checkoutPage/packagesSearch/SET_STATE';
export const SET_FETCHING = 'checkoutPage/packagesSearch/SET_FETCHING';
export const SET_PACKAGES_SEARCH_VALUE = 'checkoutPage/packagesSearch/SET_PACKAGES_SEARCH_VALUE';
export const SET_VALIDATION = 'checkoutPage/packagesSearch/SET_VALIDATION';
export const SET_HOTEL_DESTINATION_CODE = 'checkoutPage/packagesSearch/SET_HOTEL_DESTINATION_CODE';
export const RESET_STATE = 'checkoutPage/packagesSearch/RESET_STATE';
